import { TOGGLE_COLLAPSED_NAV, WINDOW_WIDTH } from 'constants/ActionTypes';

import { SettingsActionTypes } from './types/Settings';

export const toggleCollapsedNav = (payload: boolean): SettingsActionTypes => ({ type: TOGGLE_COLLAPSED_NAV, payload });
export const updateWindowWidth = (payload: number): SettingsActionTypes => ({ type: WINDOW_WIDTH, payload });
